import React from 'react'
import { NormalSystemConfigurationProvider } from 'src/Libs/shop/provider/shop-normal-system-configuration-provider'
import NormalSystemConfigurationWrapper from './NormalSystemConfigurationWrapper'

/*
 * This component wraps normal system configuration with provider
 */
const NormalSystemConfiguration: React.FC = () => {
  return (
    <NormalSystemConfigurationProvider>
      <NormalSystemConfigurationWrapper />
    </NormalSystemConfigurationProvider>
  )
}

export default NormalSystemConfiguration
